import React, { memo, useCallback, useState, useEffect } from 'react';
import Lottie from 'react-lottie-player';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import {
  IconHeart02,
  IconHeartW13,
  IconHeartW16,
  IconHeartW18,
  IconHeartW24,
  IconHeartDarkW13,
  IconHeartDarkW16,
  IconHeartDarkW18,
  IconHeartDarkW24,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import heartMotionLight from '@wconcept/wconcept-ui-renewal/public/assets/svg/heart_motion_light.json';
import heartMotionDark from '@wconcept/wconcept-ui-renewal/public/assets/svg/heart_motion_dark.json';
import heartMotionLight13 from '@wconcept/wconcept-ui-renewal/public/assets/svg/ic_like_motion_light_13_new.json';
import heartMotionLight16 from '@wconcept/wconcept-ui-renewal/public/assets/svg/ic_like_motion_light_16_new.json';
import heartMotionLight18 from '@wconcept/wconcept-ui-renewal/public/assets/svg/ic_like_motion_light_18_new.json';
import heartMotionLight24 from '@wconcept/wconcept-ui-renewal/public/assets/svg/ic_like_motion_light_24_new.json';

import * as S from './style';

interface IProps {
  active: boolean | undefined;
  heartColor?: 'white' | 'bgBlack' | 'black' | string | undefined;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    active?: boolean
  ) => Promise<void | 'SUCCESS' | 'FAIL' | null> | void;
}

const LikeBtn = ({
  active = false,
  heartColor,
  size = 'md',
  onClick,
}: IProps) => {
  const [$active, setActive] = useState(active);
  const [isMotion, setIsMotion] = useState(false);

  useEffect(() => {
    setActive(active);
  }, [active]);

  // EVENT HANDLER : 찜 하기 클릭
  const onClickHeart = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      // setActive(!$active);
      if (!$active) setIsMotion(true);
      e.preventDefault();
      if (typeof onClick === 'function') {
        const res = await onClick(e, $active);
        if (res === 'SUCCESS') {
          setActive(!$active);
        }
      }
    },
    [$active, onClick]
  );

  const getSizeLottie = () => {
    if (size === 'xs') return heartMotionLight13;
    if (size === 'sm') return heartMotionLight16;
    if (size === 'md' || size === 'lg') return heartMotionLight18;
    if (size === 'xl') return heartMotionLight24;
    return undefined;
  };

  const getIcon = () => {
    if (size === 'xs') {
      if (heartColor === 'white' || heartColor === 'bgBlack') {
        return <IconHeartDarkW13 />;
      }
      if (heartColor === 'black') {
        return <IconHeartDarkW13 />;
      }
      return <IconHeartW13 />;
    }

    if (size === 'sm') {
      if (heartColor === 'white' || heartColor === 'bgBlack') {
        return <IconHeartDarkW16 />;
      }
      if (heartColor === 'black') {
        return <IconHeartDarkW16 />;
      }
      return <IconHeartW16 />;
    }

    if (size === 'md' || size === 'lg') {
      if (heartColor === 'white' || heartColor === 'bgBlack') {
        return <IconHeartDarkW18 />;
      }
      if (heartColor === 'black') {
        return <IconHeartDarkW18 />;
      }
      return <IconHeartW18 />;
    }

    if (size === 'xl') {
      if (heartColor === 'white' || heartColor === 'bgBlack') {
        return <IconHeartDarkW24 />;
      }
      if (heartColor === 'black') {
        return <IconHeartDarkW24 />;
      }
      return <IconHeartW24 />;
    }

    return undefined;
  };

  return (
    <S.LikeBtn
      // href="#none"
      className={classNameBind([
        'like-pick',
        $active ? ' active' : '',
        heartColor ? `heartColor-${heartColor}` : '',
      ])}
      size={size}
      label="찜 하기"
      icon={
        $active ? (
          <Lottie
            animationData={getSizeLottie()}
            play
            goTo={isMotion ? 4 : 30}
            loop={false}
          />
        ) : (
          getIcon()
        )
      }
      onClick={onClickHeart}
    />
  );
};

export default memo(LikeBtn);
